import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import GeneralForm from '../../../components/generalForm';
import { useSmsCreate } from '../apiHooks';
import utils from '../../../utils/utils';
import MultiSelect from '../../../components/customFields/multiSelect';
import AutoResizeTextarea from '../../../components/customFields/autoResizeTextarea';

function SmsForm({ intl, selectedDeliveries, onSuccess }) {
  const [sms, setSms] = useState({
    deliveryIds: selectedDeliveries.map((delivery) => delivery.id),
  });

  const {
    createSms,
    isLoading: loading,
    isError: isError,
    error: vehicleEditError,
  } = useSmsCreate((resultVehicle) => onSuccess(resultVehicle));

  const deliveryOptions = selectedDeliveries
    ? selectedDeliveries.map((delivery) => {
        return {
          value: delivery.id,
          label: `#${delivery.id} - ${delivery.name}`,
        };
      })
    : [];

  const formSchema = {
    type: 'object',
    required: [],
    properties: {
      content: {
        type: 'string',
        title: intl.formatMessage({ id: 'sms.form.field.content.label' }),
      },
      deliveryIds: {
        type: 'number',
        title: intl.formatMessage({ id: 'sms.form.field.delivery.ids.label' }),
        options: deliveryOptions,
      },
    },
  };

  const uiSchema = {
    content: {
      'ui:field': 'autoResizeTextarea',
    },
    deliveryIds: {
      'ui:field': 'multiSelect',
    },
  };

  const onFormSubmit = () => {
    try {
      createSms({ sms });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  };

  const formFields = {
    multiSelect: MultiSelect,
    autoResizeTextarea: AutoResizeTextarea,
  };

  const buttonCopy = 'sms.create.form.submit';

  return (
    <div>
      <GeneralForm
        onChange={(event) => setSms(event.formData)}
        onSubmit={onFormSubmit}
        formSchema={formSchema}
        formUiSchema={uiSchema}
        formFields={formFields}
        formData={sms}
        buttonCopy={buttonCopy}
        errorMessage={isError ? utils.getErrorMessageFromResponse(vehicleEditError, true) : null}
        loading={loading}
        hideImageUpload={true}
      />
    </div>
  );
}

SmsForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

SmsForm.defaultProps = {
  onSuccess: () => {},
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

const mapDispatchToProps = {};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SmsForm));
